// PoliticaPrivacidade.js
import React, { useEffect } from "react";
import "./PoliticaPrivacidade.css";

export default function PoliticaPrivacidade() {
  useEffect(() => {
    document.title = "Política de Privacidade – LGPD | Nórea CRM";
  }, []);

  return (
    <main
      className="politica-page"
      role="main"
      aria-labelledby="politica-title"
    >
      <header className="politica-header">
        <h1 id="politica-title" className="politica-title">
          Política de Privacidade de Dados – LGPD
        </h1>

        <p className="politica-lead">
          Esta Política descreve como a{" "}
          <strong>NOREA MARKETING ESPECIALIZADO E AUDIOVISUAL LTDA</strong> trata
          os dados pessoais inseridos pelos clientes em sua plataforma de CRM
          (Lei nº 13.709/2018).
        </p>

        <nav className="politica-toc" aria-label="Sumário">
          <div className="politica-toc__header">
            <span className="politica-toc__badge">Sumário</span>
            <span className="politica-toc__hint">
              Clique para ir direto à seção desejada.
            </span>
          </div>

          <ul className="politica-toc__list">
            <li className="politica-toc__item">
              <a className="politica-toc__link" href="#s1">
                1. Coleta e Tratamento de Dados
              </a>
            </li>
            <li className="politica-toc__item">
              <a className="politica-toc__link" href="#s2">
                2. Finalidade do Uso dos Dados
              </a>
            </li>
            <li className="politica-toc__item">
              <a className="politica-toc__link" href="#s3">
                3. Compartilhamento de Informações
              </a>
            </li>
            <li className="politica-toc__item">
              <a className="politica-toc__link" href="#s4">
                4. Segurança das Informações
              </a>
            </li>
            <li className="politica-toc__item">
              <a className="politica-toc__link" href="#s5">
                5. Responsabilidade sobre Uso do WhatsApp
              </a>
            </li>
            <li className="politica-toc__item">
              <a className="politica-toc__link" href="#s6">
                6. Direitos do Titular dos Dados
              </a>
            </li>
            <li className="politica-toc__item">
              <a className="politica-toc__link" href="#s7">
                7. Alterações desta Política
              </a>
            </li>
            <li className="politica-toc__item">
              <a className="politica-toc__link" href="#s8">
                8. Foro
              </a>
            </li>
          </ul>
        </nav>
      </header>

      <section id="s1" className="politica-section" aria-labelledby="h-s1">
        <h2 id="h-s1" className="politica-section__title">
          1. Coleta e Tratamento de Dados
        </h2>
        <p className="politica-section__text">
          Os dados cadastrados no CRM (leads, contatos, informações pessoais e
          comerciais) são de responsabilidade exclusiva do cliente. A empresa
          fornece apenas a infraestrutura tecnológica para armazenamento,
          automação e gestão. Em hipótese alguma a{" "}
          <strong>NOREA MARKETING ESPECIALIZADO E AUDIOVISUAL LTDA</strong> acessa,
          utiliza ou compartilha os contatos dos clientes sem autorização.
        </p>
      </section>

      <section id="s2" className="politica-section" aria-labelledby="h-s2">
        <h2 id="h-s2" className="politica-section__title">
          2. Finalidade do Uso dos Dados
        </h2>
        <p className="politica-section__text">
          O CRM permite que os próprios clientes gerenciem leads, contatos,
          mensagens e integrações. O tratamento é restrito à execução dos
          serviços contratados, não havendo uso para finalidades comerciais da{" "}
          <strong>NOREA MARKETING ESPECIALIZADO E AUDIOVISUAL LTDA</strong>.
        </p>
      </section>

      <section id="s3" className="politica-section" aria-labelledby="h-s3">
        <h2 id="h-s3" className="politica-section__title">
          3. Compartilhamento de Informações
        </h2>
        <p className="politica-section__text">
          Os dados podem transitar por integrações autorizadas pelo cliente (ex.:
          WhatsApp, Meta Ads, Google, servidores de hospedagem). O cliente é
          responsável por configurar e validar o uso dessas integrações.
        </p>
      </section>

      <section id="s4" className="politica-section" aria-labelledby="h-s4">
        <h2 id="h-s4" className="politica-section__title">
          4. Segurança das Informações
        </h2>
        <p className="politica-section__text">
          A <strong>NOREA MARKETING ESPECIALIZADO E AUDIOVISUAL LTDA</strong> adota
          medidas técnicas e administrativas para proteção dos dados contra
          acessos não autorizados. Todavia, não se responsabiliza por falhas
          decorrentes de mau uso da conta pelo cliente (como compartilhamento de
          senhas, uso em dispositivos não seguros, etc.).
        </p>
      </section>

      <section id="s5" className="politica-section" aria-labelledby="h-s5">
        <h2 id="h-s5" className="politica-section__title">
          5. Responsabilidade sobre Uso do WhatsApp
        </h2>
        <p className="politica-section__text">
          O envio de mensagens em massa ou em desacordo com as políticas do
          WhatsApp pode acarretar banimento do número. A{" "}
          <strong>NOREA MARKETING ESPECIALIZADO E AUDIOVISUAL LTDA</strong> não se
          responsabiliza por eventuais bloqueios, suspensões ou sanções
          aplicadas pelas plataformas de terceiros. É dever do cliente respeitar
          as normas do WhatsApp e demais serviços integrados.
        </p>
      </section>

      <section id="s6" className="politica-section" aria-labelledby="h-s6">
        <h2 id="h-s6" className="politica-section__title">
          6. Direitos do Titular dos Dados
        </h2>
        <p className="politica-section__text">
          Os titulares dos dados (leads e clientes finais) podem solicitar
          acesso, correção, portabilidade ou exclusão de suas informações
          diretamente ao CONTRATANTE (usuário do CRM). A{" "}
          <strong>NOREA MARKETING ESPECIALIZADO E AUDIOVISUAL LTDA</strong> não se
          relaciona diretamente com os titulares dos dados cadastrados.
        </p>
      </section>

      <section id="s7" className="politica-section" aria-labelledby="h-s7">
        <h2 id="h-s7" className="politica-section__title">
          7. Alterações desta Política
        </h2>
        <p className="politica-section__text">
          A <strong>NOREA MARKETING ESPECIALIZADO E AUDIOVISUAL LTDA</strong>{" "}
          poderá atualizar esta Política de Privacidade periodicamente,
          comunicando os clientes sobre mudanças relevantes.
        </p>
      </section>

      <section id="s8" className="politica-section" aria-labelledby="h-s8">
        <h2 id="h-s8" className="politica-section__title">
          8. Foro
        </h2>
        <p className="politica-section__text">
          Fica eleito o foro da comarca de São José dos Campos, para dirimir
          quaisquer controvérsias decorrentes desta política.
        </p>
      </section>
    </main>
  );
}
